export default __webpack_public_path__ + "static/media/Tunic of Dark Malice.9d40075d.jpg";